import GiftCard, { GC_2025_1, GC_2025_2, GC_2025_LOGO, GiftCardVariants } from '../GiftCard/GiftCard';
import styles from './styles/styles.module.scss';

type GiftCardRadioButtonsProps = {
  onChange?: (e: any) => void;
  selectedVariant?: GiftCardVariants;
};

const GiftCardRadioButtons = ({ onChange, selectedVariant }: GiftCardRadioButtonsProps) => {
  const variants: GiftCardVariants[] = [GC_2025_LOGO, GC_2025_1, GC_2025_2];

  return (
    <div className={styles.container}>
      {variants.map(variant => (
        <div key={variant} className={styles.cardRadioContainer}>
          <input
            aria-label="Gift card image selection"
            aria-controls="gift-card-image-selection"
            value={variant}
            onChange={onChange}
            name="variant"
            className={styles.radioButton}
            id={variant}
            type="radio"
            checked={selectedVariant === variant}
          />
          <label htmlFor={variant} className={styles.label}>
            <GiftCard variant={variant} />
          </label>
        </div>
      ))}
    </div>
  );
};

export default GiftCardRadioButtons;
